import { render, staticRenderFns } from "./x-number-input.vue?vue&type=template&id=2f5e5e49&"
import script from "./x-number-input.vue?vue&type=script&lang=ts&"
export * from "./x-number-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5e5e49')) {
      api.createRecord('2f5e5e49', component.options)
    } else {
      api.reload('2f5e5e49', component.options)
    }
    module.hot.accept("./x-number-input.vue?vue&type=template&id=2f5e5e49&", function () {
      api.rerender('2f5e5e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/x-number-input.vue"
export default component.exports